import { WidgetContainer } from "@/layout-components/WidgetContainer";
import { getWidgetById } from "@/utils/widgets";
import StocksNews from "@/widget-components/firehose-widgets/stocks-news/StocksNews";

function StocksPage() {

  const StocksWidget = getWidgetById("StocksNews");

  return (
    <div className="flex-1 h-screen">
      {StocksWidget && (
        <WidgetContainer
          widget={StocksWidget}
          hideDefaultActions
          onPopOut={() => { }}
          onClose={() => { }}
        >
          {(options) => <StocksNews headerOptions={options} />}
        </WidgetContainer>
      )}

    </div>
  );
}

export default StocksPage;
